import React, {useEffect} from 'react';
import { useTable } from 'react-table';
import { Link } from 'react-router-dom';
import {ImageIllustration} from "../../Image/ImageIllustration";
import styles from "../../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faEdit, faExternalLink, faFemale, faMale, faXmark} from "@fortawesome/free-solid-svg-icons";
import ReactTableBase from "../../Table/ReactTableBase";
import AxiosConfig from "../../../services/AxiosConfig";
import {useModal} from "../../../contexts/ModalContext";
import {
    getParticipationStatusIcon,
    getSeanceStatusIcon,
    parseParticipationStatus
} from "../../../services/SeanceService";
import BtnSwitch from "../../Button/BtnSwitch";
import stylesSwitch from "../../Button/BtnSwitch.module.css";
import {Field, Formik} from "formik";
import {getUtilisateurStatusIcon} from "../../../services/UserService";
import RenderCellActif from "../../Table/RenderCellActif";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";

const ParticipationsTable = ({
                                 entreprise,
                                 contrat,
                                 activite,
                                 seance,
                                 participations,
                                 putActifOpenModal = null,
                                 putShowModalRatingOpenModal = null,
                                 putPresence = null,
                                 handleSubmitParticipationStatus = async (values, {setSubmitting}) => {
                                     try {
                                         const response = await AxiosConfig.post(`/admin/participations/${values.id}/status`, values);

                                         if (response.data.success) {

                                         } else {
                                             console.error('error', response.data);
                                         }
                                     } catch (error) {
                                         console.error('error', error);
                                     }
                                 }
}) => {
    const data = React.useMemo(() => participations, [participations]);
    if (!entreprise || !contrat || !seance || !seance.type) {
        return null;
    }

    const renderCellParticipant = ({ row, value }) => {
        if (!value || !value.civilite || !value.id || !value.prenom || !value.nom) return "";

        let myclass = `${styles[value.civilite]}`;
        return <span className={myclass} >
            <Link to={Routing.generate({
                route: Routing.routes.adminUtilisateur,
                params: { utilisateurId: value.id }
            })}>{value.civilite ? (value.civilite === "madame" ?
                <FontAwesomeIcon icon={faFemale}/>
                : <FontAwesomeIcon icon={faMale}/>)
                : ''} {value.nom.toUpperCase()} {value.prenom}</Link>
        </span>;
    }

    const renderCellType = ({ row, value }) => {
        return <Link to={Routing.generate({
                        route: Routing.routes.adminJustificatifsType,
                        params: { typeId: seance?.type?.id }
                    })}
                     style={{
                         color: seance?.type?.clr_font,
                         backgroundColor: seance?.type?.clr_bg,
                         padding: "5px 10px",
                     }}>
            {seance?.type?.label}
        </Link>;
    }

    const renderCellCreated = ({ value }) => {
        if (!value) return "";
        return DateService.formatDate(value);
    }

    const renderCellDate = ({ value }) => {
        if (!value) return "";
        return DateService.formatDateWithoutTime(value);
    }

    const renderCellActions = ({ row }) => {
        return (
            <div className={styles.actions}>
                <Link to={Routing.generate({
                    route: Routing.routes.adminSeanceParticipation,
                    params: { entrepriseId: entreprise.id, contratId: contrat.id, activiteId: activite.id, seanceId: seance.id, participationId: row.original.id },
                })} style={{ marginBottom: "10px", display: "flex", flexDirection: "row" }}>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    Détail
                </Link>
                <Link to={Routing.generate({
                    route: Routing.routes.adminSeanceParticipation,
                    params: { entrepriseId: entreprise.id, contratId: contrat.id, activiteId: activite.id, seanceId: seance.id, participationId: row.original.id },
                    queryParams: { mode: "creation" }
                })} style={{ marginBottom: "10px", display: "flex", flexDirection: "row" }}><FontAwesomeIcon icon={faEdit}/> Modifier</Link>
            </div>
        );
    }

    const renderCellShowModalRating = ({ value, row }) => {
        if(putShowModalRatingOpenModal === null) return value ? "Activé" : "Désactivé";
        return <BtnSwitch active={value} onToggle={() => putShowModalRatingOpenModal(row.original)} activeLabel={"Activé"} inactiveLabel={"Désactivé"} classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>;
    }

    const renderCellValidPresence = ({ value, row }) => {
        if(putPresence === null) return value ? "Présent" : "Absent";
        return <BtnSwitch active={value} onToggle={() => putPresence(row.original.participant.id, seance.id, value)} activeLabel={"Présent"} inactiveLabel={"Absent"} classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>;

        return value ?
            <span style={{ backgroundColor: "white", outline: "1px solid var(--clr-accent)", padding: "4px", display: "flex", gap: "2px", borderRadius: "4px"}}><FontAwesomeIcon style={{ color: "var(--clr-accent)"}} icon={faCheck}/> Validée</span> :
            <span style={{backgroundColor: "white", outline: "1px solid var(--clr-danger)", padding: "4px",  display: "flex", gap: "2px", borderRadius: "4px"}}><FontAwesomeIcon
               style={{ color: "var(--clr-danger)"}} icon={faXmark}/> Non validée</span>;
    }

    const renderCellRating = ({value}) => {
        return value ? value + "%" : "Non évaluée";
    }

    const renderCellStatus = ({ value, row }) => {
        return (
            <>
                <Formik
                    initialValues={{ status: value ?? "", id: row.original.id }}
                    onSubmit={handleSubmitParticipationStatus}
                    enableReinitialize
                >
                    {({isSubmitting, setFieldValue, values, submitForm}) => {
                        const handleChange = (e) => {
                            const { name, value } = e.target;
                            setFieldValue(name, value, false);
                            submitForm();
                        };

                        return (
                            <div className={styles.selectContainer}>
                                {getParticipationStatusIcon(value)}
                                <Field as="select" name="status" onChange={handleChange} className={styles.select}>
                                    <option>
                                        -- Sélectionnez un statut --
                                    </option>
                                    <option value={"-1"}>
                                        Pas enregistré
                                    </option>
                                    <option value={"-2"}>
                                        File d'attente non prioritaire
                                    </option>
                                    <option value={"0"}>
                                        File d'attente
                                    </option>
                                    <option value={"1"}>
                                        Validé
                                    </option>
                                    <option value={"2"}>
                                        Annulé par le participant
                                    </option>
                                    <option value={"3"}>
                                        Refusé
                                    </option>
                                </Field>
                            </div>
                        );
                    }
                    }
                </Formik>
            </>
        );
    }

    const columns = [
        /*{
            Header: 'Id',
            accessor: 'id',
            Cell: renderCellId,
        },*/
        {
            Header: 'Participant',
            accessor: 'participant',
            Cell: renderCellParticipant,
        },
        // {
        //     Header: 'Type d\'activité',
        //     accessor: 'type',
        //     Cell: renderCellType,
        // },
        {
            Header: 'Statut',
            accessor: 'status',
            Cell: renderCellStatus
        },
        {
            Header: 'Présence',
            accessor: 'valid_presence',
            Cell: renderCellValidPresence,
            isBoolean: true,
        },
        {
            Header: 'Note utilisateur',
            accessor: 'rating',
            Cell: renderCellRating,
        },
        {
            Header: 'Rappel note',
            accessor: 'show_modal_rating',
            Cell: renderCellShowModalRating,
            isBoolean: true,
        },
        {
            Header: 'État',
            accessor: 'actif',
            isBoolean: true,
            Cell: (props) => <RenderCellActif {...props} putActifOpenModal={putActifOpenModal} />,
        },
        {
            Header: 'Crée le',
            accessor: 'created_at',
            Cell: renderCellCreated,
        },
        {
            Header: 'Modifié le',
            accessor: 'updated_at',
            Cell: renderCellCreated,
        },
        {
            Header: 'Actions',
            id: 'actions',
            Cell: renderCellActions,
        },
    ];

    return (
        <ReactTableBase dataSource={participations} columnsData={columns} />
    );
};

export default ParticipationsTable;
